"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSnackMessage = exports.StyledSnackButton = exports.StyledSnackBoxCustom = exports.StyledSnackBox = exports.StyledSnackBottom = exports.StyledSnackTop = exports.StyledSnackRow = exports.StyledSnackContainer = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
var constants_1 = require("./constants");
var getStyles = function (variant) {
    var _a;
    var styles = (_a = {},
        _a[constants_1.SUCCESS] = {
            backgroundColor: theme_1.colors.green1,
        },
        _a[constants_1.WARNING] = {
            backgroundColor: theme_1.colors.amber,
        },
        _a[constants_1.ERROR] = {
            backgroundColor: theme_1.colors.red1,
        },
        _a[constants_1.INFO] = {
            backgroundColor: theme_1.colors.grey7,
        },
        _a[constants_1.CUSTOM] = {
            backgroundColor: theme_1.colors.grey7,
        },
        _a);
    return styles[variant];
};
exports.StyledSnackContainer = styled_components_1.default.div({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    justifyContent: 'space-between',
    left: '0px',
    padding: theme_1.scaffolding.sm,
    pointerEvents: 'none',
    position: 'fixed',
    top: '0px',
    width: '100%',
    zIndex: theme_1.depths.snack,
});
exports.StyledSnackRow = styled_components_1.default.div((_a = {},
    _a[theme_1.mediaQuery(theme_1.breakpoints.md)] = {
        display: 'flex',
        justifyContent: 'space-between',
    },
    _a));
var StyledSnackGroup = styled_components_1.default.div({
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: "0px " + theme_1.scaffolding.sm,
});
exports.StyledSnackTop = styled_components_1.default(StyledSnackGroup)({});
exports.StyledSnackBottom = styled_components_1.default(StyledSnackGroup)({
    justifyContent: 'flex-end',
});
exports.StyledSnackBox = styled_components_1.default.div({
    alignItems: 'center',
    borderRadius: '5px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    boxSizing: 'border-box',
    color: theme_1.colors.white,
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '26px',
    padding: theme_1.scaffolding.md,
    svg: {
        marginRight: theme_1.scaffolding.sm,
    },
    transition: '.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) all',
    width: '100%',
}, function (_a) {
    var variant = _a.variant;
    return (__assign({}, getStyles(variant)));
});
exports.StyledSnackBoxCustom = styled_components_1.default.div({
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    transition: '.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) all',
});
exports.StyledSnackButton = styled_components_1.default.div({
    display: 'block',
    pointerEvents: 'auto',
});
exports.StyledSnackMessage = styled_components_1.default.div({
    alignItems: 'center',
    display: 'flex',
});
//# sourceMappingURL=styles.js.map